// ============================================================
// translations.js — All EN/AR text strings
// ============================================================

export const text = 
{
  en: {
    // Header
    title: "My Escalations",
    subtitle: "Track and manage your escalated complaints to higher management",

    // Buttons
    createEscalation: "Create New Escalation",
    cancelEscalation: "Cancel",
    viewDetails: "View Details",
    submitting: "Submitting...",
    submit: "Submit ",

    // Tabs
    myEscalations: "My Escalations",
    assignedEscalations: "Assigned Escalations",

    // Status
    statusNotAssigned: "Not Assigned",
    statusPending: "Pending",
    statusInProgress: "In Progress",
    statusResolved: "Resolved",
    statusRejected: "Rejected",

    // Filters
    searchPlaceholder: "Search by ID, type...",
    allStatuses: "All Statuses",
    allPriorities: "All Priorities",
    filterByStatus: "Filter by Status",
    filterByPriority: "Filter by Priority",
    sortByDate: "Order by date",

    // Statistics
    totalEscalations: "Total Escalations",
    pendingEscalations: "Pending",
    resolvedEscalations: "Resolved",
    inProgressEscalations: "In Progress",
    updateStatus: "Update Status",
    allTypes: "All Types",
    allStatus: "All Status",
    newestFirst: "Newest First",
    oldestFirst: "Oldest First",
    groupLabel: "Group",
    allGroups: "All Groups",
    selectType: "Select type",

    // Table Headers
    escalationId: "ID",
    subject: "Subject",
    status: "Status",
    priority: "Priority",
    createdDate: "Created",
    lastUpdate: "Last Update",
    actions: "Actions",
    escalationLevel: "Level",
    assignedTo: "Assigned To",

    // Actions
    followUp: "Follow-up",

    // Empty States
    noEscalations: "No escalations found",
    noEscalationsMessage: "You haven't created any escalations yet",
    noSentEscalations: "No sent escalations",
    noSentEscalationsMessage: "No escalations have been sent to management",

    // Modal - Create Escalation
    createEscalationTitle: "Create New Escalation",
    escalationDetails: "Escalation Details",
    employeeName: "Employee Name",
    employeeId: "Employee ID",
    department: "Department",
    escalationType: "Escalation Type",
    escalationReason: "Escalation Reason",
    selectReason: "Select Reason",
    description: "Description",
    selectPriority: "Select Priority",
    attachments: "Attachments",
    uploadFiles: "Upload Files",
    escalationHistory: "Escalation History",
    currentStatus: "Current Status",
    cancel: "Cancel",
    close: "Close",

    // Placeholders
    enterSubject: "Enter escalation subject",
    describeIssue: "Describe your issue in detail...",
    additionalDetails:
      "Provide any additional details that may help resolve this issue",

    // Messages
    loading: "Loading...",
    confirmCancel: "Are you sure you want to cancel this escalation?",
    escalationCancelled: "Escalation cancelled successfully",
    failedToCancel: "Failed to cancel escalation",
    escalationCreated: "Escalation created successfully!",
    failedToCreate: "Failed to create escalation",
    subjectRequired: "Subject is required",
    reasonRequired: "Reason is required",
    descriptionRequired: "Description is required",
    priorityRequired: "Priority is required",

    // Types
    type_abusive: "Abusive Behaviour",
    type_employee_complain: "Employee Complaint",
    type_ticket_issue: "Ticket Issue",
    type_policy_violation: "Policy Violation",
    type_technical_issue: "Technical Issue",
    type_other: "Other",

    // Detail labels
    na: "N/A",
    detail_type: "Type",
    detail_status: "Status",
    detail_group: "Group",
    detail_issuer_sr: "Issuer SR",
    detail_issuer_name_ar: "Issuer Name (Arabic)",
    detail_issued_at: "Issued At",
    detail_description: "Description",
    update_status: "Update Status",
    mark_in_progress: "Mark In Progress",
    mark_resolved: "Mark Resolved",
    mark_rejected: "Mark Rejected",
    no_description_provided: "No description provided",
  },
  ar: {
    // Header
    title: "شكاوي",
    subtitle: "تتبع وإدارة الشكاوى أمام الجهات المختصة",

    // Buttons
    createEscalation: "شكوى جديدة",
    submit: "إرسال الشكوى",
    submitting: "جاري الإرسال...",

    // Tabs
    myEscalations: "شكاويي",
    sentEscalations: "الشكاوى المرسلة",
    assignedEscalations: "الشكاوى المسندة",

    // Status
    statusNotAssigned: "غير معين",
    statusPending: "قيد الانتظار",
    statusInProgress: "قيد المعالجة",
    statusResolved: "تم الحل",
    statusRejected: "مرفوض",

    // Priority
    priorityLow: "منخفضة",
    priorityMedium: "متوسطة",
    priorityHigh: "عالية",
    priorityCritical: "حرجة",

    // Complaint Reasons
    reasonSalary: "مشكلة في الراتب",
    reasonLeave: "طلب إجازة",
    reasonWorkload: "عبء عمل زائد",
    reasonHarassment: "تحرش",
    reasonDiscrimination: "تمييز",
    reasonSafety: "مشكلة أمان",
    reasonEquipment: "مشكلة في المعدات",
    reasonTraining: "طلب تدريب",
    reasonPerformance: "تقييم الأداء",
    reasonOther: "أخرى",

    // Filters
    searchPlaceholder: "البحث بالرقم، الموضوع...",
    allStatuses: "كل الحالات",
    allPriorities: "كل الأولويات",
    filterByStatus: "تصفية حسب الحالة",
    filterByPriority: "تصفية حسب الأولوية",

    // Statistics
    totalEscalations: "إجمالي الشكاوى",
    pendingEscalations: "قيد الانتظار",
    resolvedEscalations: "تم الحل",
    inProgressEscalations: "قيد المعالجة",
    updateStatus: "تحديث الحالة",
    allTypes: "كل الأنواع",
    allStatus: "كل الحالات",
    sortByDate: "رتب حسب التاريخ",
    newestFirst: "الأحدث أولا",
    oldestFirst: "الأقدم أولا",
    groupLabel: "المجموعة",
    allGroups: "كل المجموعات",
    selectType: "اختر النوع",

    // Table Headers
    escalationId: "الرقم",
    subject: "الموضوع",
    status: "الحالة",
    priority: "الأولوية",
    createdDate: "تاريخ الإنشاء",
    lastUpdate: "آخر تحديث",
    actions: "الإجراءات",
    escalationLevel: "المستوى",
    assignedTo: "مسند إلى",

    // Actions
    viewDetails: "عرض التفاصيل",
    cancelEscalation: "إلغاء",
    followUp: "متابعة",

    // Empty States
    noEscalations: "لا توجد شكاوى",
    noEscalationsMessage: "لم تقم بتقديم أي شكاوى بعد",
    noSentEscalations: "لا توجد شكاوى مرسلة",
    noSentEscalationsMessage: "لم يتم إرسال أي شكاوى للإدارة",

    // Modal - Create Complaint
    createEscalationTitle: "إنشاء شكوى جديدة",
    escalationDetails: "تفاصيل الشكوى",
    employeeName: "اسم الموظف",
    employeeId: "رقم الموظف",
    department: "القسم",
    escalationType: "نوع الشكوى",
    escalationReason: "سبب الشكوى",
    selectReason: "اختر السبب",
    description: "الوصف",
    selectPriority: "اختر الأولوية",
    attachments: "المرفقات",
    uploadFiles: "رفع الملفات",
    escalationHistory: "سجل الشكوى",
    currentStatus: "الحالة الحالية",
    cancel: "إلغاء",
    close: "إغلاق",

    // Placeholders
    enterSubject: "أدخل موضوع الشكوى",
    describeIssue: "اشرح المشكلة بالتفصيل...",
    additionalDetails:
      "قدم أي تفاصيل إضافية قد تساعد في حل هذه المشكلة",

    // Messages
    loading: "جاري التحميل...",
    confirmCancel: "هل أنت متأكد من إلغاء هذه الشكوى؟",
    escalationCancelled: "تم إلغاء الشكوى بنجاح",
    failedToCancel: "فشل في إلغاء الشكوى",
    escalationCreated: "تم تقديم الشكوى بنجاح!",
    failedToCreate: "فشل في تقديم الشكوى",
    subjectRequired: "الموضوع مطلوب",
    reasonRequired: "السبب مطلوب",
    descriptionRequired: "الوصف مطلوب",
    priorityRequired: "الأولوية مطلوبة",

    // Types
    type_abusive: "سلوك مسيء",
    type_employee_complain: "شكوى موظف",
    type_ticket_issue: "مشكلة في التذكرة",
    type_policy_violation: "انتهاك سياسة",
    type_technical_issue: "مشكلة فنية",
    type_other: "أخرى",

    // Detail labels
    na: "غير متاح",
    detail_type: "النوع",
    detail_status: "الحالة",
    detail_group: "المجموعة",
    detail_issuer_sr: "رقم المبلّغ",
    detail_issuer_name_ar: "اسم المبلّغ (بالعربية)",
    detail_issued_at: "تاريخ الإرسال",
    detail_description: "الوصف",
    update_status: "تحديث الحالة",
    mark_in_progress: "وضع قيد المعالجة",
    mark_resolved: "وضع تم الحل",
    mark_rejected: "وضع مرفوض",
    no_description_provided: "لا يوجد وصف مقدم",
  },
    
};

// Escalation type → translation key map
export const TYPE_KEY_MAP = {
  "ABUSIVE BEHAVIOUR": "type_abusive",
  "EMPLOYEE COMPLAIN": "type_employee_complain",
  "TICKET ISSUE": "type_ticket_issue",
  "POLICY VIOLATION": "type_policy_violation",
  "TECHNICAL ISSUE": "type_technical_issue",
  OTHER: "type_other",
};

// Status → translation key map
export const STATUS_KEY_MAP = {
  NOT_ASSIGNED: "statusNotAssigned",
  PENDING: "statusPending",
  IN_PROGRESS: "statusInProgress",
  RESOLVED: "statusResolved",
  REJECTED: "statusRejected",
};

// All escalation type values
export const ESCALATION_TYPES = [
  "ABUSIVE BEHAVIOUR",
  "EMPLOYEE COMPLAIN",
  "TICKET ISSUE",
  "POLICY VIOLATION",
  "TECHNICAL ISSUE",
  "OTHER",
];

// All status values
export const STATUS_OPTIONS = [
  "NOT_ASSIGNED",
  "PENDING",
  "IN_PROGRESS",
  "RESOLVED",
  "REJECTED",
];